'use strict';

import createResponder from './createResponder';

export {
  createResponder
}


// WEBPACK FOOTER //
// ./node_modules/react-native-gesture-responder/library/index.js